var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#e4a38b",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12 14v-4",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.1135 18.493c.3922.6666-.0885 1.507-.8619 1.507h-16.50318c-.77342 0-1.25407-.8404-.86194-1.507l8.25162-14.02771c.3866-.65731 1.3372-.65731 1.7238 0z",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 17.5c.2761 0 .5-.2239.5-.5s-.2239-.5-.5-.5-.5.2239-.5.5.2239.5.5.5z",
    fill: "#e4a38b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertOrange);
export default __webpack_public_path__ + "static/media/alert_orange.18bc01c27823bb314ce68fc8a5c1fe59.svg";
export { ForwardRef as ReactComponent };